<template>
    <el-dialog v-model="opened" title="管理手办" width="80%" :before-close="close">
        <div style="display:flex;gap:20px">
            <div style="flex:1">
                <div style="display:flex;flex-direction:column;gap:8px;">
                    <div v-if="this.figure">{{ this.figure.nickname }}</div>
                    <el-upload action="/cms/v1/resource" :show-file-list="false"
                        :headers="{ authorization: $root.authorization }" :data="{ prefix: 'origin' }" accept="image/*"
                        :disabled="loading" :onProgress="handleProgress" :on-success="handleCoverSuccess"
                        :on-error="handleUploadError">
                        <el-image :loading="loading" v-if="figure?.resource_url"
                            :src="`${$root.cdn_url}/${figure.resource_url}`"
                            style="width:120px;object-fit:cover"></el-image>
                    </el-upload>
                </div>
                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
                    <b>已选关卡 ({{ selected.length }})</b>
                    <el-button text :disabled="loading" @click="clearSelected">清空</el-button>
                </div>
                <vue-draggable-next v-model="selected" item-key="id" :animation="300" handle=".handle">
                    <transition-group>
                        <el-card v-for="img in selected" :key="img.id" shadow="hover" style="margin-bottom:8px">
                            <div style="display:flex;justify-content:space-between;align-items:center">
                                <div style="display:flex;gap:8px;align-items:center">
                                    <el-button circle class="handle" icon="Sort" size="small"></el-button>
                                    <el-image :src="imageSrc(img)"
                                        style="width:140px;height:90px;object-fit:cover"></el-image>
                                    <div>{{ img.nickname || img.id }}</div>
                                </div>
                                <el-button type="danger" size="small" @click="removeSelected(img)">移除</el-button>
                            </div>
                        </el-card>
                    </transition-group>
                </vue-draggable-next>
            </div>
            <div style="flex:1">
                <div style="display:flex;gap:8px;align-items:center;margin-bottom:8px">
                    <el-input v-model="query.nickname" placeholder="搜索关卡..." :disabled="loading"></el-input>
                    <el-button :loading="loading" @click="fetchImages(1)">查询</el-button>
                </div>
                <div style="display:flex;flex-wrap:wrap;gap:12px">
                    <el-card v-for="img in images" :key="img.id" shadow="never" style="width:160px"
                        :class="{ 'selected': tempSelectedIds.includes(img.id) }" @click="toggleTemp(img)">
                        <el-image :src="imageSrc(img)" style="width:100%;height:100px;object-fit:cover"></el-image>
                        <div style="text-align:center;margin-top:6px">{{ img.nickname || img.id }}</div>
                    </el-card>
                </div>
                <div style="display:flex;justify-content:space-between;align-items:center;margin-top:10px">
                    <div>已勾选 {{ tempSelectedIds.length }} 个关卡</div>
                    <div>
                        <el-button text @click="tempSelectedIds = []" :disabled="loading">清空勾选</el-button>
                        <el-button type="primary" :loading="loading" @click="addTempToSelected">添加选中项</el-button>
                    </div>
                </div>
            </div>
        </div>

        <template #footer>
            <el-button text @click="close" :disabled="loading">取消</el-button>
            <el-button type="primary" :loading="loading" @click="save">保存</el-button>
        </template>
    </el-dialog>
</template>

<script>
import axios from 'ts-axios-new';
import { VueDraggableNext } from 'vue-draggable-next';
import { update } from '../../libs/utils';
import { ElMessage } from 'element-plus';

export default {
    name: 'FigureImagesDialog',
    components: { VueDraggableNext },
    data() {
        return {
            opened: false,
            loading: false,
            figure: null,
            selected: [], // image objects
            images: [], tempSelectedIds: [],
            query: { nickname: null, skip: 0, limit: 20 },
        }
    },
    methods: {
        imageSrc(img) {
            return `${this.$root.cdn_url}/${img.thumbnail || img.resource || img.url || img.underlay || ''}`;
        },
        async open(figure) {
            this.figure = figure;
            this.opened = true;
            this.loading = true;
            try {
                // 拉取已关卡详情
                this.selected = [];
                for (const id of figure.images || []) {
                    try { const r = await axios.get(`/cms/v1/image/${id}`); this.selected.push(r.data?.data || { id }); } catch (e) { }
                }
            } finally {
                this.loading = false;
            }
            this.fetchImages(1);
        },
        close() {
            this.loading = false;
            this.figure = null;
            this.selected = [];
            this.opened = false;
        },
        fetchImages(page) {
            this.query.skip = page - 1; this.loading = true;
            axios.get('/cms/v1/image', { params: this.query }).then(res => {
                this.images = res.data?.data?.imageList || res.data?.data?.list || [];
                this.loading = false;
            }).catch(err => {
                this.loading = false;
                ElMessage.error('获取图片失败，请稍后重试');
                console.error(err);
            });
        },
        toggleTemp(img) {
            const i = this.tempSelectedIds.indexOf(img.id);
            if (i >= 0) this.tempSelectedIds.splice(i, 1); else this.tempSelectedIds.push(img.id);
        },
        addTempToSelected() {
            const addIds = new Set(this.tempSelectedIds);
            this.images.forEach(i => { if (addIds.has(i.id) && !this.selected.find(s => s.id === i.id)) this.selected.push(i); });
            this.tempSelectedIds = [];
        },
        removeSelected(img) {
            const i = this.selected.indexOf(img); if (i >= 0) this.selected.splice(i, 1);
        },
        clearSelected() { this.selected.splice(0, this.selected.length); },
        save() {
            const ids = this.selected.map(i => i.id);
            this.loading = true;
            axios.patch(`/cms/v1/figure/${this.figure.id}`, {
                username: this.$root.user.name,
                images: ids,
                resource_url: this.figure.resource_url
            }).then(res => {
                update(this.figure, res.data?.data || { images: ids });
                this.$emit('updated', this.figure);
                this.close();
            }).catch(err => {
                this.loading = false;
                ElMessage.error('保存失败，请稍后重试');
                console.error(err);
            });
        },
        handleCoverSuccess(res) { this.figure.resource_url = res.data.name; this.loading = false; },
        handleProgress() { this.loading = true; },
        handleUploadError() {
            this.loading = false;
            ElMessage.error('上传失败，请稍后重试');
        }
    }
}
</script>

<style scoped>
.selected {
    border-color: var(--el-color-primary);
}
</style>